import { useGetOrganizationPaymentPlanQuery } from '@/services/organizations';
import { OrganizationNode } from '@/types/Organizations';
import { Box } from '@palmetto/palmetto-components';

import { ProgramType } from 'types';

import { PaymentPlanTable } from '../../../Payouts/PaymentPlanTable';
import PaymentCard from '../components/PaymentCard';

interface PaymentPlanProps {
  organization: OrganizationNode;
  programType: ProgramType;
  orgHasSignatoryEmails?: boolean;
}

export const PaymentPlan = ({ organization, programType, orgHasSignatoryEmails }: PaymentPlanProps) => {
  const { data: paymentPlan, isLoading: isLoadingPaymentPlan } = useGetOrganizationPaymentPlanQuery({
    alias: organization.alias,
    programType: programType,
  });
  const renderPaymentPlan = (content: React.ReactNode) => (
    <PaymentCard
      isLoading={isLoadingPaymentPlan}
      organization={organization}
      cardTitle="Payment Plan"
      href={`/settings/organizations/${organization?.alias}/payments/${programType}/edit`}
      isInherited={paymentPlan?.inherited}
      orgHasSignatoryEmails={orgHasSignatoryEmails}
    >
      {content}
    </PaymentCard>
  );

  if (!paymentPlan) {
    return renderPaymentPlan(
      <Box alignItems="center" justifyContent="space-evenly" height="300px">
        <Box>No Payment Schedule</Box>
      </Box>,
    );
  }

  return renderPaymentPlan(<PaymentPlanTable paymentPlans={[paymentPlan]} programType={programType} />);
};
